import { render } from "./Post.vue?vue&type=template&id=1ae07c00&scoped=true"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"

import "./Post.vue?vue&type=style&index=0&id=1ae07c00&scoped=true&lang=css"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae07c00"]])

export default __exports__